import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=7a638dda&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"
import style0 from "./FormPage.vue?vue&type=style&index=0&id=7a638dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a638dda",
  null
  
)

export default component.exports